import { Injectable } from '@angular/core';
import { InputModality, InputModalityDetector } from '@angular/cdk/a11y';

/**
 * Closes the one gap `:focus-visible` can't express on its own: user agents
 * deliberately match it on pointer focus for text inputs/textareas, so a
 * click there would still show the ring. Toggles `rv-pointer-modality` on
 * `<html>`, which `focus-outline()` (`src/scss/mixins.scss`) uses to
 * suppress the ring regardless of `:focus-visible` (PRD FOC-04, Tech Spec
 * DF-10). Instantiated once at bootstrap via `APP_INITIALIZER` in
 * `app.module.ts` and lives for the app's lifetime.
 */
@Injectable({
  providedIn: 'root',
})
export class FocusModalityService {
  constructor(private inputModalityDetector: InputModalityDetector) {
    this.applyModality(this.inputModalityDetector.mostRecentModality);
    this.inputModalityDetector.modalityChanged.subscribe((modality) =>
      this.applyModality(modality),
    );
  }

  private applyModality(modality: InputModality) {
    document.documentElement.classList.toggle(
      'rv-pointer-modality',
      modality === 'mouse' || modality === 'touch',
    );
  }
}
